"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringTypeMap = exports.utf8String = exports.fixedSizeUtf8String = void 0;
const types_1 = require("../types");
const assert_1 = require("assert");
const numbers_1 = require("./numbers");
const utils_1 = require("../utils");
/**
 * De/Serializes a UTF8 string of a particular size.
 *
 * @param stringByteLength the number of bytes of the string
 *
 * @category beet/collection
 */
const fixedSizeUtf8String = (stringByteLength) => {
    return {
        write: function (buf, offset, value) {
            const stringBuf = Buffer.from(value, 'utf8');
            assert_1.strict.equal(stringBuf.byteLength, stringByteLength, `${value} has invalid byte size`);
            numbers_1.u32.write(buf, offset, stringByteLength);
            stringBuf.copy(buf, offset + 4, 0, stringByteLength);
        },
        read: function (buf, offset) {
            const size = numbers_1.u32.read(buf, offset);
            assert_1.strict.equal(size, stringByteLength, `invalid byte size`);
            const stringSlice = buf.slice(offset + 4, offset + 4 + stringByteLength);
            return stringSlice.toString('utf8');
        },
        elementByteSize: 1,
        length: stringByteLength,
        lenPrefixByteSize: 4,
        byteSize: 4 + stringByteLength,
        description: `Utf8String(4 + ${stringByteLength})`,
    };
};
exports.fixedSizeUtf8String = fixedSizeUtf8String;
/**
 * De/Serializes a UTF8 string of any size.
 *
 * @category beet/collection
 */
exports.utf8String = {
    toFixedFromData(buf, offset) {
        const len = numbers_1.u32.read(buf, offset);
        (0, utils_1.logTrace)(`${this.description}[${len}]`);
        return (0, exports.fixedSizeUtf8String)(len);
    },
    toFixedFromValue(val) {
        const len = Buffer.from(val).byteLength;
        return (0, exports.fixedSizeUtf8String)(len);
    },
    description: `Utf8String`,
};
/**
 * Maps string beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */
exports.stringTypeMap = {
    fixedSizeString: {
        beet: 'fixedSizeUtf8String',
        isFixable: false,
        sourcePack: types_1.BEET_PACKAGE,
        ts: 'string',
        arg: types_1.BEET_TYPE_ARG_LEN,
    },
    string: {
        beet: 'utf8String',
        isFixable: true,
        sourcePack: types_1.BEET_PACKAGE,
        ts: 'string',
    },
};
//# sourceMappingURL=string.js.map